const pct = (db) => Math.max(0, Math.min(100, ((db + 60) / 60) * 100));

/** Real input meter, −60 … 0 dBFS: green (safe) · amber (strong) · red (too hot), with a CLIP light. */
export default function LevelMeter({ peakDb, rmsDb, clipped, onResetClip, testId = "level-meter", big = false }) {
  return (
    <div data-testid={testId} className="w-full">
      <div className={`relative overflow-hidden rounded-full bg-white/[0.06] ${big ? "h-5" : "h-3"}`}>
        <div aria-hidden className="absolute inset-y-0 left-[70%] w-px bg-white/25" />
        <div aria-hidden className="absolute inset-y-0 left-[90%] w-px bg-white/25" />
        <div className="absolute inset-y-0 left-0 rounded-full bg-gradient-to-r from-emerald-400 via-emerald-300 to-amber-300 opacity-60 transition-[width] duration-75" style={{ width: `${pct(rmsDb)}%` }} />
        <div className={`absolute inset-y-0 w-1 rounded-full transition-[left] duration-75 ${peakDb > -3 ? "bg-rose-400" : peakDb > -12 ? "bg-amber-300" : "bg-emerald-300"}`} style={{ left: `calc(${pct(peakDb)}% - 2px)` }} />
      </div>
      <div className="mt-1.5 flex items-center justify-between font-mono text-[10px] uppercase tracking-wider text-white/45">
        <span>−60</span><span>−18</span><span>−6</span>
        <span data-testid={`${testId}-peak`} className="normal-case text-white/80">{peakDb > -119 ? `${peakDb.toFixed(1)} dB` : "—"}</span>
        <button type="button" data-testid={`${testId}-clip`} onClick={onResetClip} title="Click to reset"
          className={`rounded px-1.5 py-0.5 font-bold transition-colors duration-150 ${clipped ? "bg-rose-500 text-white" : "bg-white/[0.06] text-white/30"}`}>Clip</button>
      </div>
    </div>
  );
}
